import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import GlobalModel from 'echarts/lib/model/Global';
import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import RoamModel from './RoamModel';
import RoamView from './RoamView';
import { installRoamAction } from './roamAction';
import { doubleYAxisHack } from './doubleYAxisHack';

export function install(registers: EChartsExtensionInstallRegisters) {
  // @ts-ignore
  registers.registerComponentView(RoamView);
  registers.registerComponentModel(RoamModel);

  registers.registerUpdateLifecycle('afterupdate', (ecModel: GlobalModel, api: ExtensionAPI) => {
    const roamModel = ecModel.getComponent('roam');
    if (roamModel) {
      doubleYAxisHack(ecModel, api);
      const roamView = api.getViewOfComponentModel(roamModel) as unknown as RoamView;
      if (roamView) {
        roamView.setCenterAndZoom();
      }
    }
  });

  installRoamAction(registers);
}
